import React, { useContext, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ReactGA from "react-ga4";
import PrivateRoute from "./components/PrivateRoute";
import AlertBar from "./components/AlertBar";
import AppLayout from "./layout";
import UploadProgressModal from "./components/Modals/UploadProgress";
// import { useAdvancedAnalytics } from "./customHooks/useAdvancedAnalytics";
import { AuthContext } from "./contexts/AuthContext";
// const ViewPeople = React.lazy(() => import("pages/app/users/people"));

import ExploreAI from "./pages/app/exploreAI/explore_ai";
import ExploreEvents from "./components/Sections/ExploreEvents";
import BackdropLoader from "./components/BackdropLoader";

const LoginView = React.lazy(() => import("./pages/auth/login"));
const MainView = React.lazy(() => import("./pages"));
const ErrorView = React.lazy(() => import("./pages/error"));
const PrivacyPolicyView = React.lazy(() =>
  import("./pages/privacy_policy/index")
);
const TaskCreate = React.lazy(() => import("./pages/app/taskCreate"));
const TaskEdit = React.lazy(() => import("./pages/app/taskEdit"));
//UserView
// const ViewContent = React.lazy(() => import("./pages/app/content"));
// const ViewVideos = React.lazy(() => import("./pages/app/videos"));
const ViewTaskManagement = React.lazy(() =>
  import("./pages/app/task_management")
);
const ViewSlackConfig = React.lazy(() =>
  import("./pages/app/slack_config")
);
// const ViewTeamPerformance = React.lazy(() => import("./pages/app/team_performance"));
const ViewUsers = React.lazy(() => import("./pages/app/users"));
// const ViewProjects = React.lazy(() => import("./pages/app/projects"));
const ViewDashboard = React.lazy(() => import("./pages/app/dashboard"));
const ViewPosts = React.lazy(() => import("./pages/app/posts"));
const ViewExploreAI = React.lazy(() =>
  import("./pages/app/exploreAI/control_view_explore_ai")
);
const ViewRepository = React.lazy(() =>
  import("./pages/app/repository")
);
const TimelineClickable = React.lazy(() => import("./components/Sections/TimelineClickable"));
const PublishPreview = React.lazy(() => import("./components/Task/PublishPreview"));
const LinkMatching = React.lazy(() => import("./pages/linkMatching"));


function App() {
  // const [activateLog, setActivateLog] = useState(false);
  const { user } = useContext(AuthContext);
  // const { user } = useContext(AuthContext);
  // const { smarDashboardSession } = useAdvancedAnalytics(
  //   activateLog,
  //   setActivateLog,
  //   user?.pk
  // );
  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID);
  }, []);

  useEffect(() => {
    if (user) {
      ReactGA.set({ user_id: user.pk });
    }
  }, [user]);
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginView />} />
        <Route
          path="/password_reset"
          element={<LoginView isResetScreen={true} />}
        />
        <Route
          path="/password_reset/confirm/*"
          element={<LoginView isResetPassword={true} />}
        />

        <Route path="/privacy_policy" element={<PrivacyPolicyView />} />
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<MainView />} />
          <Route path="/app" element={<AppLayout />}>
            {/* <Route path="content" element={<ViewContent />} />
            <Route path="videos" element={<ViewVideos />} /> */}
            <Route path="work_board" element={<ViewTaskManagement />} />
            <Route path="work_board/slack_config" element={<ViewSlackConfig />} />
            <Route
              path="work_board/link_matching"
              element={<LinkMatching />}
            />
            <Route path="users" element={<ViewUsers />} />
            <Route path="posts/*" element={<ViewPosts />} />
            <Route path="repository" element={<ViewRepository />} />
            <Route path="dashboard/*" element={<ViewDashboard />} />
            <Route path="task">
              <Route path="create" element={<TaskCreate />} />
              <Route path="edit/:taskId" element={<TaskEdit />} />
              <Route path="publish/:taskId" element={<PublishPreview />} />
            </Route>
            <Route path="explore_ai" element={<ViewExploreAI />}>
              <Route index element={<ExploreAI />} />
              <Route path="events" element={<ExploreEvents />}>
                <Route path=":eventId" element={<ExploreEvents />} />
              </Route>
              <Route
                path="timeline/:subEventId/:rootId"
                element={<TimelineClickable />}
              />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<ErrorView />} />
      </Routes>
      <AlertBar />
      <UploadProgressModal />
      <BackdropLoader />
    </Router>
  );
}

export default App;
